import { useMemo } from "react";
import AllPlans from "./AllPlans";
import MetricsPlans from "./MetricsPlans";

export const useTabDetails = (metricsList: string[]) => {
  return useMemo(() => {
    const metricsNames = metricsList?.map((metric: string) => ({
      label: metric,
      content: Hoc(MetricsPlans, metric)
    }));
    let tabDetails: any = [
      {
        label: "All",
        content: AllPlans
      }
    ];
    if (metricsNames) {
      tabDetails = [...tabDetails, ...metricsNames];
    }

    return tabDetails;
  }, [metricsList]);
};

const Hoc = (WrappedComponent: any, metricsName: any) => {
  return (props: any) => {
    return <WrappedComponent {...props} metricsName={metricsName} />;
  };
};
